export default "__VITE_ASSET__C3897MO2__"